import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './Catering.css';

const Catering = () => {
  return (
    <div className="catering-page">
      <PageBanner
        title="Catering Services"
        image={productionRouteBanners.catering}
        imageAlt={productionRouteBannerAlts.catering}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Catering</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Delicious cuisine and impeccable service for your event
            </p>
          </div>
          
          <div className="about-content">
            <p>
              From elegant plated dinners to lavish buffets, our catering services ensure 
              your guests enjoy exceptional food and service. We work with the finest chefs 
              and use quality ingredients to create memorable dining experiences.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Catering;
